export const submenu = () => {
    const menu = document.querySelector('.menu') as HTMLElement
    if (!menu) return
    const menuItemsHasChilds = menu?.querySelectorAll('.menu__item.has-childs') as NodeListOf<HTMLLIElement>
    const thirdmenus = menu?.querySelectorAll('.thirdmenu') as NodeListOf<HTMLDivElement>

    menuItemsHasChilds?.forEach(menuItemHasChilds => {
        const subtitle = menuItemHasChilds.querySelector('.submenu > .submenu__list > .submenu__title') as HTMLLIElement

        menuItemHasChilds.addEventListener('click', e => {
            e.stopPropagation()

            const target = e.target as HTMLElement

            if (menuItemHasChilds.classList.contains('open') && target.classList.contains('first-level-link')) {
                menuItemHasChilds.classList.remove('open')
                return
            }

            if (e.target !== subtitle) {
                menuItemHasChilds.classList.add('open')
                
                const activeMenu = menuItemHasChilds

                menuItemsHasChilds.forEach(item => {
                    if (item !== activeMenu) {
                        item.classList.remove('open')
                    }
                })
            }
        })

        subtitle.addEventListener('click', () => {
            menuItemHasChilds.classList.remove('open')
        })

    })

    window.addEventListener('click', e => {
        const elem = e.target as HTMLElement;
        if (elem.closest('.menu__item.has-childs')) return
        menuItemsHasChilds.forEach(menuItemHasChilds => menuItemHasChilds.classList.remove('open'))
        thirdmenus.forEach(thirdmenu => thirdmenu.classList.remove('active'))
    })
}
